/**
 * Created by sange on 15/08/2017.
 */
import * as menuActions from '../actions/menu.actions'

export interface State {
  selectedItem: string,
}

export const initialState: State = {
  selectedItem: '/'
}

export function reducer(state = initialState, action: menuActions.Actions): State {
  switch (action.type) {

    case menuActions.SELECT_MENU_ITEM: {
      return {
        selectedItem: action.payload
      } as State
    }

    default: {
      return state
    }
  }
}

export const getSelectedItem = (state: State) => state.selectedItem




// WEBPACK FOOTER //
// ./src/app/shared/navbar/menu/store/reducers/menu.reducer.ts